import React from 'react'

export interface FeedbackTextProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  children?: React.ReactNode;
  bg?: boolean;
}

export function ErrorText({
  className,
  children,
  ...attributes
}: FeedbackTextProps) {
  const errorTextClassNames = `text-warning ${className || ""}`;

  return (
    <div className={errorTextClassNames} {...attributes}>
      {children}
    </div>
  );
}
